import API_BASE_URL from '../Config';

const PERMISO_API = `${API_BASE_URL}/permisos`;

/**
 * Obtiene todos los permisos.
 */
export const getPermisos = async () => {
    const response = await fetch(PERMISO_API, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error('Error al obtener los permisos');
    return await response.json();
};

export const getPermisoById = async (id) => {
    const response = await fetch(`${PERMISO_API}/${id}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error('Error al obtener el permiso');
    return await response.json();
};

export const createPermiso = async (dt) => {
    const response = await fetch(PERMISO_API, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(dt)
    });
    if (!response.ok) throw new Error('Error al crear el permiso');
    return await response.json();
};

export const updatePermiso = async (id, dt) => {
    const response = await fetch(`${PERMISO_API}/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(dt)
    });
    if (!response.ok) throw new Error('Error al actualizar el permiso');
    return await response.json();
};

export const deletePermiso = async (id) => {
    const response = await fetch(`${PERMISO_API}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
    });
    if (!response.ok) throw new Error('Error al eliminar el permiso');
    return true;
};
